import { computeScale, computeRelativeScale } from "./math";
import { animateVisionSimulations } from "./vision_simulator";

/**
 * Set value and position for range input elements.
 * @param {value} number;
 * @param {HTMLInputElement} rangeInput
 * @param {HTMLElement} label
 * @param {HTMLElement} track
 */
function setRangeInputElements(value, rangeInput, label, track) {
    const rangeThumbPosition = computeScale(
        100,
        Number(value),
        Number(rangeInput.min),
        Number(rangeInput.max)
    );
    const widthDifference = computeRelativeScale(
        -value,
        0,
        label.clientWidth,
        -rangeInput.min,
        -rangeInput.max
    );

    label.innerText = parseFloat(value).toFixed(2) + "D";
    label.style.right = `calc(${rangeThumbPosition}% - ${widthDifference}px)`;
    track.style.width = `calc(${
        100 - rangeThumbPosition
    }% + ${widthDifference}px)`;
}
/**
 * @param {number} rangeValue
 */
function showCurrentBlurredImage(rangeValue) {
    const covers = document.querySelectorAll(".div-cover");
    const plainValue = String(rangeValue).replace(/\W/g, "");

    covers.forEach((cover) => {
        [...cover.children].forEach((image) => {
            if (!image?.src) return;

            if (image.src.includes(plainValue)) {
                image.classList.add("show-blur-image");
            } else {
                image.classList.remove("show-blur-image");
            }
        });
    });
}

/**
 * Change blurred images on static vision simulator pages.
 */
export function getVisionImagesStatically() {
    const diopterRangeInput = document.querySelector("#static-simulator-range");
    const diopterLabel = document.getElementById("diopter-label");
    const diopterTrack = document.getElementById("diopter-track");

    if (!diopterRangeInput) return;

    updateDiopter(
        diopterRangeInput.value,
        diopterRangeInput,
        diopterLabel,
        diopterTrack
    );

    transitAnimatedDiopter(
        -3,
        -1,
        diopterRangeInput,
        diopterLabel,
        diopterTrack
    );

    diopterRangeInput.addEventListener("input", (event) => {
        const rangeValue = Number(event.target.value).toFixed(1);
        updateDiopter(
            rangeValue,
            diopterRangeInput,
            diopterLabel,
            diopterTrack
        );
    });
}

/**
 * Update diotper value and position.
 * @param {number} value
 * @param {HTMLInputElement} diopterRangeInput
 * @param {HTMLElement} diopterLabel
 * @param {HTMLElement} diopterTrack
 */
function updateDiopter(value, diopterRangeInput, diopterLabel, diopterTrack) {
    setDiopterValue(value, diopterRangeInput);
    setRangeInputElements(value, diopterRangeInput, diopterLabel, diopterTrack);
    showCurrentBlurredImage(value);
}

/**
 * Set diotper input value;
 * @param {number} value
 * @param {HTMLInputElement} diopterRangeInput
 */
function setDiopterValue(value, diopterRangeInput) {
    diopterRangeInput.value = value;
    diopterRangeInput.setAttribute("value", value);
}

/**
 * Transit diopter position.
 * @param {number} initialValue
 * @param {number} limit
 * @param {HTMLInputElement} diopterRangeInput
 * @param {HTMLElement} diopterLabel
 * @param {HTMLElement} diopterTrack
 */
function transitAnimatedDiopter(
    initialValue,
    limit,
    diopterRangeInput,
    diopterLabel,
    diopterTrack
) {
    let currentValue = initialValue;

    const diopterInterval = setInterval(() => {
        if (currentValue >= limit) {
            if (limit > initialValue) {
                updateDiopter(
                    (limit -= 1),
                    diopterRangeInput,
                    diopterLabel,
                    diopterTrack
                );
            } else {
                animateVisionSimulations();
                clearInterval(diopterInterval);
                diopterLabel.classList.remove("transition");
            }
        } else {
            updateDiopter(
                (currentValue += 1),
                diopterRangeInput,
                diopterLabel,
                diopterTrack
            );
        }
    }, 520);
}

export function setStaticBlurImage() {
    const input = document.querySelector("#vision-simulator-static-image");

    if (!input) {
        throw new Error("vision simulator input not found");
    }

    const animations = document.querySelectorAll(".animate-simulation");
    const staticBlurImages = document.querySelectorAll(".static-blur-image");
    const staticImageTexts = document.querySelectorAll(".static-image-texts");

    input.addEventListener("input", () => {
        staticBlurImages.forEach((staticItems) => {
            staticItems.classList.toggle("d-none");
        });

        staticImageTexts.forEach((staticImageText) => {
            staticImageText.classList.toggle("d-flex");
            staticImageText.classList.toggle("d-none");
        });

        animations.forEach((animations) => {
            animations.classList.remove("active");
        });
    });
}

window.addEventListener("load", () => {
    try {
        getVisionImagesStatically();
        setStaticBlurImage();
    } catch (error) {
        console.info(error);
    }
});
